module.exports = __webpack_public_path__ + "img/live_biaoqing.064a5865.png";